export enum InspectionType {
	None = 0,
	Fixture = 10,
	Gauge = 20,
	ThreeDimensionalScan = 30,
	PPAP = 40,
	OneOffScan = 50,
	FrontSheet = 60,
}